export const DEFAULT_LISTING_PAGE_SIZE = 25;

export const LISTING_PAGE_SIZE_OPTIONS = [25, 100, 250, 1000];
